<template>
    <div id='menu_bar' class='menu-container'>
        <div class='item-headings'>
            <a class='item-heading-text' v-for='heading in headings' :key="heading.id" :href="(heading.type == 'CU') ? heading.custom_url : `/${heading.sef_url}`" @mouseover='hoverMenuItem(heading.id)' @click='openCategory($event, heading)'>
                {{heading.name}}
            </a>
        <DesktopMenuPopout :selected_heading='selected_heading' @selectedMenuItemListener='selectedMenuItem' @cancelHideListener="cancelHide" @hideMenuListener="hideMenu"/>
        </div>

    </div>
</template>

<script>
import DesktopMenuPopout from '@/ecom/components/navigation/header/menus/DesktopMenuPopout.vue';

export default {
    components:{DesktopMenuPopout},
    props: ['menu_items', 'headings', 'sub_headings'],
    data(){
        return{
            selected_heading: [],
            showTimer: null,
            hideTimer: null,
            hover_menu_delay: 200
        }
    },
    methods:{
        hoverMenuItem(heading_id){
            clearTimeout(this.hideTimer);
            this.selected_heading = this.menu_items.filter(x=>x.id == heading_id)[0];
            this.showMenu();
        },
        openCategory(e, category){
            this.hideMenu();
            if(e.ctrlKey) {
                return;
            } else {
                e.preventDefault();
                let url = (category.type == 'CU') ? category.custom_url : `/${category.sef_url}`;
                this.$router.push(url);
            }
        },
        selectedMenuItem(e, category){
            this.hideMenu();
            if(e.ctrlKey) {
                return;
            } else {
                e.preventDefault();
                let url = (category.type == 'CU') ? category.custom_url : `/${category.sef_url}`;
                this.$router.push(url);
            }
        },
        handleMenuHover(){
            const isHover = e => e.parentElement.querySelector(':hover') === e;

            document.addEventListener('mousemove', checkHover => {
                const menu_bar = isHover(document.getElementById('menu_bar'));

                if (menu_bar !== checkHover.hovered) {
                    if(!menu_bar){

                        this.hideMenu();
                    }

                    checkHover.hovered = menu_bar;
                }
            });
        },
        showMenu(){
            clearTimeout(this.hideTimer);
            this.showTimer = setTimeout(() => {
                const menu = document.getElementById('menu');
                if(menu){
                    menu.classList.remove('hidden');      
                }         
                //document.getElementById('menu').classList.remove('hidden');
            }, this.hover_menu_delay);
        },
        hideMenu(){
            clearTimeout(this.showTimer);
            clearTimeout(this.hideTimer);
            this.hideTimer = setTimeout(() => {
                const menu = document.getElementById('menu');
                if(menu){
                    menu.classList.add('hidden');
                }
                //document.getElementById('menu').classList.add('hidden');
            }, this.hover_menu_delay - 100);
        },
        cancelHide() {
            clearTimeout(this.hideTimer);
        }
    },
    mounted(){
        this.handleMenuHover();
    }
}
</script>

<style lang="scss" scoped>
.menu-container{
    position: relative;
    display: flex;
    justify-content: center;
    height: var(--desktop-menu-container-height);
    align-items: center;
    // background-color: var(--top-nav-bar-background-colour);
    // border-bottom: solid 1px #ced4da;
    // border-top: solid 1px #ced4da;

    @media(max-width: 768px){
        display: none;
    }
}

.item-headings{
    display: flex;
    font-size: 0.78rem;
    height: 100%;
    cursor: pointer;
    // text-transform: uppercase;
}

.item-heading-text{
    align-content: center;   
    padding-left: 25px;
    padding-right: 25px;
    text-decoration: none;
    color: white;
}

.item-heading-text:hover{
    background-color: #85858583;
    border-radius: 0.4rem;
    // color: var(--primary-colour-1);
}

</style>